import { FormControl, FormLabel } from "@chakra-ui/react"
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { getAxiosInstance } from "../../../utils/axiosInstance";
import { Select } from "chakra-react-select";

interface AddPlaceOfBusiness {
  companyId: string;
  selectedPlaceOfBusiness: string;
  setSelectedPlaceOfBusiness: (value: string) => void;
  customTitle?: string;
}

const AddPlaceOfBusiness = (props: AddPlaceOfBusiness) => {

  const {
    companyId,
    selectedPlaceOfBusiness,
    setSelectedPlaceOfBusiness
  } = props;

  const { t } = useTranslation('translations');

  const [formattedList, setFormattedList] = useState<{ value: string; label: string; colorScheme: string }[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const fetch = async (companyId: string) => {
    setIsLoading(true);
    try {
      const res = await getAxiosInstance().get(`/Companies/company-place-of-business/${companyId}`);
      setFormattedList(res.data.map((x: any) => ({ value: x.id, label: x.name, colorScheme: "yellow" })))
    } catch (e) {
      console.log(e);
    } finally {
      setIsLoading(false);
    }
  }

  useEffect(() => {
    if (companyId) fetch(companyId);
  }, [companyId]);


  return (
    <FormControl>
      <FormLabel>{props.customTitle ?? t("SELECT_PLACE_OF_BUSINESS")}</FormLabel>
      <Select
        isRequired
        name={t("SELECT_PLACE_OF_BUSINESS")}
        options={formattedList}
        value={
          formattedList.findIndex((x) => x.value === selectedPlaceOfBusiness) != -1
            ? formattedList[
            formattedList.findIndex((x) => x.value === selectedPlaceOfBusiness)
            ]
            : null
        }
        tagVariant="solid"
        placeholder={t("SELECT_PLACE_OF_BUSINESS_PLACEHOLDER")}
        onChange={(e) => {
          if (e) setSelectedPlaceOfBusiness(e.value);
        }}
        isLoading={isLoading}
      />
    </FormControl>
  );
}

export default AddPlaceOfBusiness;